import { Button, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { FormatDataByTypeCode } from "../../form-client";
import { isNullOrUndefined, openForm } from "../WidgetUtil";
import { WidgetColumn } from "../Widget";

interface ClientPortalEventsTableProps {
	Columns: Array<WidgetColumn>;
	Data: Array<any>;
	Refresh: Function;
}

export function ClientPortalEventsTable(props: ClientPortalEventsTableProps) {
	const visColumns = props.Columns.filter((x) => x.IsListed && !x.IsCustomColumn).sort((a, b) => a.ColumnOrder - b.ColumnOrder);

	const completeTask = async (row: any, event?: React.MouseEvent) => {
		if (event) {
			event.stopPropagation();
		}

		const parentValue =
			row.is_people || row.is_people0
				? row.people_id || row.people_id0
				: row.units_id || row.units_id0 || row.group_profile_id || row.group_profile_id0 || row.people_id || row.people_id0;

		const eventLogId = row.event_log_id ?? row.event_log_id0;
		const completeSchedEvent = isNullOrUndefined(eventLogId);
		const keyValue = completeSchedEvent ? row.events2do_id || row.events2do_id0 || "NEW" : eventLogId;

		const win = await openForm(
			row.event_form_header_id || row.event_form_header_id0 || row.form_header_id || row.form_header_id0,
			keyValue,
			"EDIT",
			row.event_definition_id || row.event_definition_id0,
			row.program_responsible || row.program_responsible0 || row.program_providing_service || row.program_providing_service0,
			row.site_providing_service || row.site_providing_service0,
			parentValue,
			completeSchedEvent,
			row.program_enrollment_event_id || row.program_enrollment_event_id0,
			row.service_track_event_id || row.service_track_event_id0,
			row.units_id || row.units_id0
		);

		const interval = setInterval(() => {
			if (win?.closed) {
				props.Refresh();
				clearInterval(interval);
			}
		}, 2000);
	};

	return (
		<Table size="small">
			<TableHead>
				<TableRow>
					{visColumns.map((x) => (
						<TableCell key={x.ColumnName}>{x.Caption}</TableCell>
					))}
					<TableCell align="right" />
				</TableRow>
			</TableHead>
			<TableBody>
				{props.Data.map((row: any, idx: number) => {
					const isCompleteTask = isNullOrUndefined(row.event_log_id ?? row.event_log_id0);
					return (
					<TableRow
						key={idx}
						hover
						onClick={() => completeTask(row)}
						sx={{
							cursor: "pointer",
							backgroundColor: idx % 2 === 0 ? "white" : "#f2f2f2",
						}}>
						{visColumns.map((col: WidgetColumn) => (
							<TableCell
								key={col.ColumnName}
								sx={{ padding: "6px 8px", verticalAlign: "middle" }}
								dangerouslySetInnerHTML={{
									__html: FormatDataByTypeCode(row[col.ColumnName], col.TypeCode),
								}}
							/>
						))}
						<TableCell align="right" sx={{ padding: "6px 8px", whiteSpace: "nowrap" }}>
							<Button
								variant="contained"
								color="primary"
								size="small"
								onClick={(event) => completeTask(row, event)}>
								{isCompleteTask ? "Complete Task" : "Edit Record"}
							</Button>
						</TableCell>
					</TableRow>
				);
				})}
			</TableBody>
		</Table>
	);
}
